/**
 * CSP configuration and reporting version.
 *
 * Bump CSP_VERSION when you intentionally change the effective Content-Security-Policy.
 * This value is sent as `v` to PostHog CSP reports so you can correlate violations
 * with specific policy revisions.
 */
export const CSP_VERSION = "2026-07-11";

/** Public PostHog project token used for the /report/ CSP ingestion endpoint. */
export const POSTHOG_CSP_REPORT_TOKEN =
  "phc_rKgyvFjGJt36YBBcPMo7DV2pD34n4WRt7NX5VuAwHr7n";

/** PostHog host for reports (US cloud). */
export const POSTHOG_REPORT_HOST = "https://us.i.posthog.com";
